/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mFirendLeasderBroard.vue?vue&type=template&id=55202104&scoped=true"
import script from "./mFirendLeasderBroard.vue?vue&type=script&lang=js"
export * from "./mFirendLeasderBroard.vue?vue&type=script&lang=js"
import style0 from "./mFirendLeasderBroard.vue?vue&type=style&index=0&id=55202104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55202104",
  null
  
)

export default component.exports